import { Pressable, Text, View } from 'react-native';
import { useRouter } from 'expo-router';
import { Ionicons } from '@expo/vector-icons';
import { useAuth } from '../context/AuthContext';
import { GradientCard } from './ui';
import { fonts, gradients } from '../theme';

function ChecklistRow({ label, done }: { label: string; done: boolean }) {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 6 }}>
      <Ionicons
        name={done ? 'checkmark-circle' : 'ellipse-outline'}
        size={18}
        color={done ? '#fff' : 'rgba(255,255,255,0.6)'}
      />
      <Text
        style={{
          color: done ? 'rgba(255,255,255,0.75)' : '#fff',
          fontFamily: done ? fonts.regular : fonts.semiBold,
          fontSize: 14,
          textDecorationLine: done ? 'line-through' : 'none',
        }}
      >
        {label}
      </Text>
    </View>
  );
}

/** No-reward onboarding nudge — the underlying items already unlock real
 * value on their own (identity/payout unlock withdrawal, avatar builds
 * trust), so this just makes the "you're not done yet" state visible
 * instead of paying coins for something users benefit from anyway. Hides
 * itself entirely once all three are complete. */
export function ProfileChecklistCard() {
  const { user } = useAuth();
  const router = useRouter();
  if (!user) return null;

  const hasAvatar = !!user.avatarUrl;
  const hasIdentity = !!user.hasIdentityOnFile;
  const hasPayout = !!user.payoutAccountNumber;
  if (hasAvatar && hasIdentity && hasPayout) return null;

  return (
    <Pressable onPress={() => router.push('/profile')}>
      <GradientCard colors={gradients.primary} style={{ marginBottom: 16 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, marginBottom: 8 }}>
          <Ionicons name="person-circle" size={14} color="#fff" />
          <Text style={{ color: '#fff', fontFamily: fonts.bold, fontSize: 12, letterSpacing: 0.4 }}>
            NHIỆM VỤ NỀN TẢNG
          </Text>
        </View>
        <Text style={{ fontSize: 16, fontFamily: fonts.bold, color: '#fff', marginBottom: 6 }}>
          Hoàn thiện hồ sơ
        </Text>
        <ChecklistRow label="Ảnh đại diện" done={hasAvatar} />
        <ChecklistRow label="Xác minh CCCD/CMND" done={hasIdentity} />
        <ChecklistRow label="Tài khoản nhận tiền" done={hasPayout} />
      </GradientCard>
    </Pressable>
  );
}
